import React from 'react';
import { LegalPage } from '../components/legal/LegalPage';

const sections = [
  {
    heading: '1. Préambule',
    blocks: [
      { type: 'p', content: "La présente politique de confidentialité a pour objet d'informer les utilisateurs du site www.mmd-conseils.fr sur la manière dont MMD CONSEIL collecte, utilise et protège leurs données personnelles." },
      { type: 'p', content: "MMD CONSEIL s'engage à traiter les données personnelles conformément au Règlement Général sur la Protection des Données (RGPD) et à la législation française applicable." },
    ],
  },
  {
    heading: '2. Responsable du traitement',
    blocks: [
      { type: 'p', content: "Le responsable du traitement des données est :" },
      { type: 'p', content: "MMD CONSEIL\n220 Avenue Victor Hugo\n69140 Rillieux-la-Pape\n\nE-mail : contact@mmd-conseils.fr\nTéléphone : 06 67 30 88 94" },
    ],
  },
  {
    heading: '3. Données collectées',
    blocks: [
      { type: 'p', content: "Dans le cadre de l'utilisation du site, les données suivantes peuvent être collectées :" },
      { type: 'list', content: [
        "Nom et prénom",
        "Adresse e-mail",
        "Numéro de téléphone",
        "Nom de l'entreprise",
        "Toute information communiquée volontairement via les formulaires de contact",
        "Adresse IP",
        "Données de navigation nécessaires au fonctionnement du site",
      ] },
    ],
  },
  {
    heading: '4. Finalités du traitement',
    blocks: [
      { type: 'p', content: "Les données collectées sont utilisées pour :" },
      { type: 'list', content: [
        "Répondre aux demandes de contact",
        "Établir des devis ou propositions commerciales",
        "Assurer le suivi de la relation client",
        "Respecter les obligations légales et réglementaires",
        "Garantir la sécurité du site internet",
      ] },
    ],
  },
  {
    heading: '5. Base légale du traitement',
    blocks: [
      { type: 'p', content: "Les traitements reposent sur :" },
      { type: 'list', content: [
        "Le consentement de l'utilisateur",
        "L'exécution de mesures précontractuelles",
        "L'exécution d'un contrat",
        "Le respect des obligations légales",
        "L'intérêt légitime de MMD CONSEIL",
      ] },
    ],
  },
  {
    heading: '6. Durée de conservation',
    blocks: [
      { type: 'p', content: "Les données sont conservées :" },
      { type: 'list', content: [
        "3 ans à compter du dernier contact pour les prospects",
        "Pendant toute la durée de la relation contractuelle pour les clients",
        "Puis archivées selon les obligations légales applicables",
      ] },
    ],
  },
  {
    heading: '7. Destinataires des données',
    blocks: [
      { type: 'p', content: "Les données sont exclusivement destinées à MMD CONSEIL." },
      { type: 'p', content: "Elles ne sont ni vendues ni cédées à des tiers." },
      { type: 'p', content: "Toutefois, certains prestataires techniques (hébergeur, maintenance informatique) peuvent être amenés à y accéder dans le strict cadre de leurs missions." },
    ],
  },
  {
    heading: '8. Sécurité des données',
    blocks: [
      { type: 'p', content: "MMD CONSEIL met en œuvre toutes les mesures techniques et organisationnelles appropriées afin de garantir la sécurité, l'intégrité et la confidentialité des données personnelles." },
    ],
  },
  {
    heading: '9. Droits des personnes concernées',
    blocks: [
      { type: 'p', content: "Conformément au RGPD, chaque utilisateur dispose :" },
      { type: 'list', content: [
        "D'un droit d'accès",
        "D'un droit de rectification",
        "D'un droit d'effacement",
        "D'un droit d'opposition",
        "D'un droit à la limitation du traitement",
        "D'un droit à la portabilité de ses données",
      ] },
      { type: 'p', content: "Toute demande peut être adressée à : contact@mmd-conseils.fr" },
      { type: 'p', content: "L'utilisateur dispose également du droit d'introduire une réclamation auprès de la Commission Nationale de l'Informatique et des Libertés (CNIL)." },
    ],
  },
  {
    heading: '10. Modification de la politique',
    blocks: [
      { type: 'p', content: "MMD CONSEIL se réserve le droit de modifier la présente politique à tout moment afin de garantir sa conformité avec la réglementation en vigueur." },
    ],
  },
];

const PolitiqueConfidentialite = () => (
  <LegalPage
    title="Politique de confidentialité"
    intro="Comment MMD CONSEIL collecte, utilise et protège vos données personnelles, conformément au RGPD."
    seoDescription="Politique de confidentialité de MMD CONSEIL : collecte, utilisation et protection des données personnelles conformément au RGPD."
    path="/politique-de-confidentialite"
    sections={sections}
  />
);

export default PolitiqueConfidentialite;
